import { useCallback, useState } from 'react';
import { message } from 'antd';
import { auditLogApi, AuditLogEntry, AuditLogFilter } from '../../../services/auditLogApi';

const DEFAULT_FILTER: AuditLogFilter = { page: 1, pageSize: 20 };

/** Fetches + paginates SYS_AuditLog rows. Purely a data hook — no JSX. */
export function useAuditLogQuery() {
  const [data, setData] = useState<AuditLogEntry[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState<AuditLogFilter>(DEFAULT_FILTER);

  const search = useCallback(async (next?: Partial<AuditLogFilter>) => {
    const merged: AuditLogFilter = { ...filter, ...next };
    setFilter(merged);
    setLoading(true);
    try {
      const res = await auditLogApi.list(merged);
      setData(res.data);
      setTotal(res.total);
    } catch {
      message.error('查詢稽核記錄失敗');
    } finally {
      setLoading(false);
    }
  }, [filter]);

  const reset = useCallback(() => search(DEFAULT_FILTER), [search]);

  const changePage = useCallback((page: number, pageSize: number) => {
    search({ page, pageSize });
  }, [search]);

  return { data, total, loading, filter, search, reset, changePage };
}
